// src/components/forms/shared/NotesModal.tsx
// Componente reutilizable para mostrar y editar notas
// Usado por: OrderForm y CotizacionForm

import React from 'react'
import { DocumentTextIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Textarea } from '../../ui'
import { FormField } from '../../ui/Form'

interface NotesModalProps {
  showModal: boolean
  setShowModal: (show: boolean) => void
  note: string
  onNoteChange: (value: string) => void
  mode: 'view' | 'edit' | 'create'
  title?: string
  placeholder?: string
  position?: 'right-8' | 'right-4'
  buttonStyle?: 'rounded-full' | 'rounded-none'
}

export const NotesModal: React.FC<NotesModalProps> = ({
  showModal,
  setShowModal,
  note,
  onNoteChange,
  mode,
  title = 'Notas',
  placeholder = 'Ingrese las notas...',
  position = 'right-8',
  buttonStyle = 'rounded-full'
}) => {
  const hasNote = note && note.trim().length > 0

  return (
    <div className={`fixed ${position} top-24 z-50`}>
      <div className="relative flex items-center gap-2">
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowModal(!showModal)}
            className={`bg-blue-800 text-white ${buttonStyle} p-3 shadow-lg hover:bg-blue-900 transition-colors`}
          >
            <DocumentTextIcon className="h-5 w-5" />
          </button>
          {hasNote && (
            <div className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
              !
            </div>
          )}
        </div>
      </div>
      
      {/* Modal de notas */}
      {showModal && (
        <div className={`absolute ${position === 'right-8' ? 'right-0' : 'right-12'} mt-2 w-80 bg-white rounded-lg shadow-xl p-4`}>
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-semibold text-blue-800">{title}</h3>
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
          <FormField>
            <Textarea
              value={note}
              onChange={(e) => onNoteChange(e.target.value)}
              rows={8}
              placeholder={placeholder}
              readOnly={mode === 'view'}
              mode={mode}
            />
          </FormField>
        </div>
      )}
    </div>
  )
}
